import React from 'react';

import './App.css';

import UserCard from "./components/UserCard"
import Top100User from "./components/Top100User"

// 试验性功能
// import json from "./mock/users.json" assert { type: 'json' };
// console.log(`json =`, json);

// const users = require("./mock/users.json");
// console.log(`users =`, users);

import json from "./mock/users.json"
console.log(`users =`, json.items);

const users = json.items;

const data = {
  "login": "xgqfrms",
  "id": 7291672,
  "node_id": "MDQ6VXNlcjcyOTE2NzI=",
  "avatar_url": "https://avatars.githubusercontent.com/u/7291672?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/xgqfrms",
  "html_url": "https://github.com/xgqfrms",
  "followers_url": "https://api.github.com/users/xgqfrms/followers",
  "following_url": "https://api.github.com/users/xgqfrms/following{/other_user}",
  "gists_url": "https://api.github.com/users/xgqfrms/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/xgqfrms/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/xgqfrms/subscriptions",
  "organizations_url": "https://api.github.com/users/xgqfrms/orgs",
  "repos_url": "https://api.github.com/users/xgqfrms/repos",
  "events_url": "https://api.github.com/users/xgqfrms/events{/privacy}",
  "received_events_url": "https://api.github.com/users/xgqfrms/received_events",
  "type": "User",
  "site_admin": false,
  "score": 1.0
};

function App() {
  return (
    <div className="App">
      <h1>Top 100 GitHub Users in China</h1>
      {/* <UserCard data={data}/> */}
      <section className="user-list">
        <Top100User users={users}/>
      </section>
    </div>
  );
}

export default App;
